import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCurrentUser } from "@/lib/auth";
import { DEFAULT_HOME_PAGE, homePageRedirectSessionKey } from "@/lib/userHomePage";
import { useUserUiPreferences } from "@/lib/UserUiPreferencesProvider";

/**
 * Leitet beim ersten App-Start pro Sitzung von "/" auf die benutzerdefinierte Startseite um.
 * Spätere Navigation zu "/" (z. B. über „Dashboard“) bleibt unverändert.
 */
export function HomeStartupRedirect() {
  const { user } = useCurrentUser();
  const { homePage, ready } = useUserUiPreferences();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!ready || !user || pathname !== "/") return;

    const sessionKey = homePageRedirectSessionKey(user);
    if (!sessionKey || sessionStorage.getItem(sessionKey) === "1") return;

    sessionStorage.setItem(sessionKey, "1");
    if (homePage !== DEFAULT_HOME_PAGE) {
      navigate(homePage, { replace: true });
    }
  }, [ready, homePage, user, pathname, navigate]);

  return null;
}
